import React from "react";
// import { Link } from "react-router-dom";




export default class Contact extends React.Component {

    render(){
        return(
            <div>
                <div class="wrapper">
                     <section class="bread-crumb-container">
                        <div class="bread-crumb-img">
                            <img src="/assets/images/bread-crumb4.png" alt=""/>
                        </div>
                        <div class="bread-crumb-content">
                            <div class="bread-crumb-inner">
                            <h2>contact</h2>
                            <a href="index.html">Home</a> - <a href="contact.html">Contact</a>
                            </div>
                        </div> {/* <!-- bread-crumb-content --> */}
                    </section> {/* <!-- bread-crumb-container --> */}
                    <div class="main-part">

                        <section class="our-client-container">
                            <div class="container" style={{marginTop:35}}> 
                                <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="row">
                                        <div class="text-center col-sm-12">
                                            <h2>Find Us & Taste Tradition</h2>
                                        </div>
                                    </div> 
                                </div> {/* <!-- heading --> */}
                            </div>
                        </section>
                        <div style={{marginBottom:50}}> 
                            <span style={{fontSize:20}}>Visit us at our cafe or find the nearest <span style={{fontWeight:'700'}}>Village Cafe Food Truck.</span></span>
                        </div>
                        <div style={{marginBottom:50,marginTop:5}}> 
                            <span style={{fontSize:20}}>Or sign up for our <span style={{fontWeight:700}}>Food Subscription Plans </span>and get healthy meals delivered daily.</span>
                        </div>  


                        <section class="shedule-container contact-container">
                            <div class="shedule-part">
                            <div class="container">
                                <div class="shedule-left text-left">
                                {/* <h2>Contact us</h2>
                                <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p> */}
                                <div class="row contact-bottom">
                                    <div class="col-md-4 col-sm-12 col-xs-12 contact-add-left">
                                    {/* <div class="contact-add-inner">
                                        <span>Address</span>
                                        <p>No 13, Emerald Hills, California, USA</p>
                                    </div> */}
                                    <div class="contact-add-inner">
                                        <span>Call/WhatsApp : </span>
                                        <a href="#/">(+800) 123 456 781</a>
                                        <a href="#/">(+800) 888 999 221</a>
                                    </div>
                                    <div class="contact-add-inner">
                                        <span>Delivery Available : </span>
                                        <p>Swiggy & Zomato</p>
                                    </div>
                                    {/* <div class="contact-add-inner">
                                        <span>Email</span>
                                        <a href="mailto:galliasoft@yahoo.com">galliasoft@yahoo.com</a>
                                    </div> */}
                                    </div>
                                    <div class="col-md-8 col-sm-12 col-xs-12 contact-add-right">
                                    <form name="contact-form" method="post" action="functions.php">
                                        <div class="alert-container">
                                        <div class="alert alert-success alert-dismissible" role="alert">
                                            <button type="button" class="close"><span aria-hidden="true">&times;</span></button>
                                            <span class="alert-message"></span>
                                        </div>
                                        </div>
                                        <div class="form-field">
                                        <input name="full_name" placeholder="* Name" type="text" required/>
                                        </div> {/* <!-- form-field --> */}
                                        <div class="form-field">
                                        <input name="email_address" placeholder="* Email" type="email" required/>
                                        </div> {/* <!-- form-field --> */}
                                        <div class="form-field">
                                        <textarea name="message" placeholder="* comment" required></textarea>
                                        </div> {/* <!-- form-field --> */}
                                        <div class="form-field">
                                        <button class="btn-black">Send message</button>
                                        </div> {/* <!-- form-field --> */}
                                    </form>                   
                                    </div>
                                </div>
                                </div>
                                <div class="shedule-right">
                                    <img src="/assets/images/shedule-bg.jpg" alt=""/>
                                    <div class="shedule-content">
                                        <h2>Our Shedule</h2>
                                        <h3>Food truck</h3>
                                        <div class="shedule-inside">
                                        <h6>Monday-Friday: 800<sup>00</sup> - 2000<sup>00</sup></h6>
                                        <h6>Saturday: 900<sup>00</sup> - 1700<sup>00</sup></h6>
                                        <h6>Sunday: closed</h6>
                                        </div>
                                        <h3>Catering</h3>
                                        <div class="shedule-inside">
                                        <h6>Monday-Friday: 800<sup>00</sup> - 2400<sup>00</sup></h6>
                                        <h6>Saturday: 900<sup>00</sup> - 2200<sup>00</sup></h6>
                                        <h6>Sunday: closed</h6>
                                        </div>
                                        {/* <div class="free-juice">
                                        <p>*Daily first 5 clients receive a free juice</p>
                                        </div> */}
                                        <div class="glass">
                                        <img src="/assets/images/glass.png" alt=""/>
                                        </div>
                                </div> {/* <!-- shedule-content --> */}
                                </div>
                            </div> {/* <!-- container --> */}
                            {/* <div style={{marginBottom:50}}> 
                                <span style={{fontSize:20}}>Or sign up for our <span style={{fontWeight:700}}>Food Subscription Plans </span>and get healthy meals delivered daily.</span>
                            </div> */}

                            </div> {/* <!-- shedule-part --> */}
                            
                        </section> {/* <!-- shedule-container --> */}  
                        
                        <div class="map-outer">
                            <div id="truck-locator"></div>
                        </div>
                    </div> {/* <!-- main-part --> */}
                </div>
            </div>
        )
    }
}